/**
 * Shared constants for logger modules
 */

/**
 * Log levels supported by the logger
 */
export type LogLevel =
  | 'error'
  | 'warn'
  | 'info'
  | 'http'
  | 'verbose'
  | 'debug'
  | 'silly'

/**
 * ANSI color codes for terminal output
 */
export const ANSI_COLORS = {
  reset: '\x1b[0m',
  dim: '\x1b[2m',
  red: '\x1b[31m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  blue: '\x1b[34m',
  magenta: '\x1b[35m',
  cyan: '\x1b[36m',
  gray: '\x1b[90m',
} as const

/**
 * Log level numeric priorities (lower = more important)
 */
export const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
  error: 0,
  warn: 1,
  info: 2,
  http: 3,
  verbose: 4,
  debug: 5,
  silly: 6,
}

/**
 * ANSI colors per log level for terminal output
 */
export const LEVEL_COLORS: Record<LogLevel, string> = {
  error: ANSI_COLORS.red,
  warn: ANSI_COLORS.yellow,
  info: ANSI_COLORS.green,
  http: ANSI_COLORS.cyan,
  verbose: ANSI_COLORS.blue,
  debug: ANSI_COLORS.magenta,
  silly: ANSI_COLORS.gray,
}

/**
 * CSS colors for client-side log levels (browser console)
 */
export const CLIENT_LEVEL_COLORS: Record<string, string> = {
  error: 'color: #ef4444; font-weight: bold',
  warn: 'color: #f59e0b; font-weight: bold',
  info: 'color: #22c55e',
  debug: 'color: #a855f7',
}

/**
 * Default maximum namespace width for alignment
 */
export const MAX_NAMESPACE_WIDTH = 32
